import React, { Component } from 'react';
import _ from 'lodash';
import './index.css';
import { Link } from 'react-router-dom';
import ActionArrow from 'src-features/commonUI/arrow'

function convertMoney(amount) {
    if (!_.isNumber(+amount)) return '';
    return ((+amount)/100).toFixed(2)
}
function convertProductName(name) {
    return name.replace('-', ' ')
}
class HorizontalList extends Component {
    state={
        data: []
    }
    appendRemaining = () => {
        if(this.remain.length>0) {
            this.setState({
                data: this.state.data.concat(this.remain),
                hasMore: false
            })
            this.remain = [];
        }
    }
    componentDidMount() {
        this.remain = this.props.data.slice(12)
        this.setState({
            data: this.props.data.slice(0, 12),
            hasMore: this.remain.length > 0
        })
    }
    render() {
        const {data = [], redirect_url} = this.props;
        return (
            <div>
            <div className="list-container">
                {this.state.data.map((product, index) => (
                    <div className="list-item-container" key={index}>
                        {/* <div className="img-container" onClick={()=>handleRedirect(redirect_url)}> */}
                        <Link style={{ textDecoration: 'none' }} to={`/product/detail/${product.productId}/group/${product.groupId}`}>
                        <div className="img-container">
                            <img className="img-item" src={product.product_image.image_url}/>
                        </div>
                        <div className="item-content">
                            <span className="item-content-span">{product.name}</span>
                            <span className="item-content-span">{product.brand_name}</span>
                            <span className="item-content-span">
                            <span style={{
                                color: product.current_price < product.original_price ? '#F81F34' : 'rgba(38,39,41,0.90)'
                            }}>{`S$ ${convertMoney(product.current_price)}`}</span>
                            {product.current_price < product.original_price && <span className="orginal-price">{`S$ ${convertMoney(product.original_price)}`}</span>}
                            </span>
                        </div>
                        </Link>
                    </div>
                ))
                }
            </div>
            <div style={{textAlign: 'center'}}>
                <ActionArrow action={this.appendRemaining} hasMore={this.state.hasMore}/>
            </div>
            </div>
        )
    }
}


class Container extends Component {
    state = {data: []}
    getData = () => {
        let data = this.props.data;
        this.setState({data: data.data.street_snap.street_item_position_list});
    }

    componentDidMount() {
        this.getData();
    }
    // handleClick = (url) => () => {
    //     handleRedirect(url)
    // }
    render() {
        return (
            <div className="section-container">
            {this.state.data.map((list, index) => 
                    <div className="list-section" key={index} >
                        <div id={`${list.category.split(' ').join('_')}`} className="list-header">   
                            <h4 className="list-title section-items">{list.category}</h4>
                            {/* <span className="tips section-items" onClick={this.handleClick(list.redirect_url || list.redirect)}>More</span> */}
                        </div>
                        <HorizontalList 
                            data={list.similar_product_list}
                            streetItemID={list.street_item_id}
                            redirect_url={list.redirect_url || list.redirect} 
                        />
                    </div>
                )
            }
            </div>
        )
    }
};

export default Container


// WEBPACK FOOTER //
// ./src/features/streetSnap/streetInfluencer/component/horizontal_list/horizontal_list.jsx